module.exports = __webpack_public_path__ + "img/frente-amplio.71deae02.png";